// src/data.js
const cardData2 = [
    {
      id: 1,
      title: 'ResourceHub',
      description: 'ResourceHub is an open-source project that serves as a collection of valuable resources for web development, carefully curated by the amazing contributors in the community.',
      link1: 'https://github.com/sakshams23/ResourceHub',
      link2: 'https://github.com/jfmartinz/ResourceHub/pull/107',
    },
    {
      id: 2,
      title: 'Ultimate-Web-Dev',
      description: 'A collection of Web Developement Projects and Resources at one place offers you to a vast range of projects and resources carefully curated by the amazing contributors across community.',
      link1: 'https://github.com/sakshams23/Ultimate-Web-Development-Resources/tree/main',
      link2: 'https://github.com/DhanushNehru/Ultimate-Web-Development-Resources/pull/359',
    },
    
  ];
  
  export default cardData2;
  